import _jsx from "@babel/runtime/helpers/jsx";
import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import { SubHeading } from 'reaxl';
import EmailContext from '../EmailContext';
import EmailStaticContent from '../EmailStaticContent';

/**
 *  EmailFormTitle renders the title of the email form and/or email modal.
 *
 */
function EmailFormTitle(_ref) {
  let {
    isConfirmation = false,
    isEditEmailModal = false,
    isSmallTitle = false
  } = _ref;
  const {
    uiContext
  } = useContext(EmailContext);
  if (uiContext === 'edit' && isEditEmailModal) {
    return EmailStaticContent.title.editOnly;
  }
  if (isConfirmation) {
    return EmailStaticContent.confirmation.title;
  }
  switch (uiContext) {
    case 'calculator':
    case 'quote':
      return EmailStaticContent.title[uiContext];
    case 'calculatorOfferSummary':
    case 'default':
    case 'basic':
    case 'split':
      return /*#__PURE__*/_jsx(SubHeading, {
        size: isSmallTitle ? 400 : 500,
        className: "margin-bottom-3"
      }, void 0, EmailStaticContent.title[uiContext]);
    default:
      return EmailStaticContent.title.dealer;
  }
}
export default EmailFormTitle;